export default __webpack_public_path__ + "static/media/16.f9c3bae8.jpg";